import React from 'react';
import { Form, Slider } from 'antd';
import '../css/survey-look.css'
// import { tool } from 'modules/tool/route';
const FormItem = Form.Item;

const SurveyRangeField = props => {
  const { min, max, marks, defaultValue, step, onAfterChange, trackStyle, handleStyle, disabled,selectedId,autoscroll, ...rest } = props;
  const [default_marker,setDefaultMarker]=React.useState({})
  const [visible,setVisible]=React.useState(false)
  React.useEffect(() => {
    if(max ===100){
      setDefaultMarker({
        0: '0',
        10:'10',
        20:'20',
        30:'30',
        40:'40',
        50:'50',
        60:'60',
        70:'70',
        80:'80',
        90:'90',
        100: '100',
      })
    }
    else if(max ===10){
      setDefaultMarker({
        0: '0',
        1:'1',
        2:'2',
        3:'3',
        4:'4',
        5:'5',
        6:'6',
        7: '7',
        8: '8',
        9: '9',
        10: '10',
      })
    }
    else {
      setDefaultMarker({
        [min]: min,
        [max]: max,
      })
    }
  },[min,max])

  console.log("min, max, marks, defaultValue, step, onAfterChange, trackStyle, handleStyle, disabled,selectedId",min, max, marks, defaultValue, step, onAfterChange, trackStyle, handleStyle, disabled,selectedId)
  const rangeAfterChange =(value) => {
    onAfterChange(value)
    // if(min !== undefined && max !== undefined){
    //   setDefaultMarker({
    //     [min]: min,
    //     [value]:value,
    //     [max]: max,
    //   })
    // }
    // else{
    //   setDefaultMarker({
    //     0: '0',
    //     [value]:value,
    //     100: '100',
    //   })
    // }
    
  }
  const visibleTooltip =()=>{
    setTimeout(()=>{
      setVisible(true)
    },100)
  }
  return (
    <div className='generic-survey-range-slider' style={{ marginBottom: '5vh', padding: '0px 24px 0px 0px'}}>
      <FormItem labelCol={{ span: 24 }} wrapperCol={{ span: 24, offset: 1 }} {...rest}>
        <Slider
          id={selectedId}
          min={min}
          max={max}
          tooltipVisible={visible}
          marks={default_marker}
          defaultValue={defaultValue}
          step={max===10?0.5:1} 
          onAfterChange={e=>rangeAfterChange(e)}
          trackStyle={trackStyle}
          handleStyle={handleStyle}
          disabled={disabled}
          onChange={e=>{autoscroll&&autoscroll(selectedId);visibleTooltip()}}
        />
      </FormItem>
    </div>
  );
};

export default SurveyRangeField;
